import { useState } from 'react'
import { CreditCard, History } from 'lucide-react'
import { SegmentedControl } from '@teach/ui'
import { HistoryList } from '@/features/ai/credits/HistoryList'
import { BalanceBanner } from '../components/BalanceBanner'
import { useIsMobile } from '@/hooks/use-mobile'
import { PaymentsHistory } from '../components/PaymentsHistory'
import { useMessages } from '@/i18n'
import { messages } from './messages'

type Tab = 'usage' | 'payments'

/** Использование: баланс сверху и один список с переключателем. Это разные
 *  данные: движения кредитов (расход и начисления) и заказы на покупку. */
export const BalanceSettings = () => {
  const [tab, setTab] = useState<Tab>('usage')
  const m = useMessages(messages)
  const isMobile = useIsMobile()
  return (
    <section className="space-y-5">
      <h2 className="sr-only">{m.usage}</h2>
      <BalanceBanner />
      <SegmentedControl<Tab>
        options={[
          { id: 'usage', label: m.tabUsage, icon: History },
          { id: 'payments', label: m.tabPayments, icon: CreditCard },
        ]}
        value={tab}
        onChange={setTab}
        // На телефоне — во всю ширину, как у «Коннекторов».
        fullWidth={isMobile}
      />
      <div className="rounded-2xl bg-foreground/5 p-5">
        {tab === 'usage' ? <HistoryList capHeight={false} /> : <PaymentsHistory />}
      </div>
    </section>
  )
}
